import { Box, FormLabel, Switch } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './Switch.scss';

const AppSwitch: FC<AppSwitchProps> = ({
  id,
  label,
  required,
  valueType = 'boolean',
  checked,
  defaultChecked,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();

  const handleChange = (
    _event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    if (valueType === 'number') {
      onChange?.(checked ? 1 : 0);
    } else {
      onChange?.(checked);
    }
  };

  return (
    <Box className="AppSwitch">
      <FormLabel htmlFor={id}>{t(label!)}</FormLabel>
      <Switch
        id={id}
        name={id}
        checked={checked}
        defaultChecked={defaultChecked}
        required={required}
        onChange={handleChange}
        disabled={disabled}
      />
    </Box>
  );
};

export default AppSwitch;
